/**
 * Shared MD preloader API (insights filters, search overlay, etc.).
 * Markup: template-parts/preloaders/filter-preloader.php (.preloader)
 */
(function (window) {
	'use strict';

	function findPreloader(root) {
		if (!root) {
			return null;
		}
		if (root.classList && root.classList.contains('preloader')) {
			return root;
		}
		return root.querySelector ? root.querySelector('.preloader') : null;
	}

	function show(root) {
		var el = findPreloader(root);
		if (!el) {
			return;
		}
		// Drop/re-add so WebKit restarts CSS animation after display:none → visible.
		el.classList.remove('animate');
		void el.offsetWidth;
		el.classList.add('animate');
	}

	function hide(root) {
		var el = findPreloader(root);
		if (!el) {
			return;
		}
		el.classList.remove('animate');
	}

	function showOverlay(overlay) {
		if (!overlay) {
			return;
		}
		overlay.hidden = false;
		overlay.classList.add('is-active');
		show(overlay);
	}

	function hideOverlay(overlay) {
		if (!overlay) {
			return;
		}
		overlay.classList.remove('is-active');
		overlay.hidden = true;
		hide(overlay);
	}

	window.MobidevPreloader = {
		show: show,
		hide: hide,
		showOverlay: showOverlay,
		hideOverlay: hideOverlay,
	};
})(window);
